import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow, InlineRangeAdvancedFilter } from 'shared/components/AdvancedFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectTotalAreaAdvancedFilter } from 'shared/selectors/advancedFilters';

export const TotalAreaAdvancedContainer: FC = () => {
  const {
    value: { min: valueMin, max: valueMax },
  } = useSelector(selectTotalAreaAdvancedFilter);

  const onChange = useFilterChangeCallback();

  const handleMinChange = useCallback(
    (newMin: number | null) => {
      onChange({ action: 'setTotalAreaMin', arguments: [newMin] });
    },
    [onChange],
  );

  const handleMaxChange = useCallback(
    (newMax: number | null) => {
      onChange({ action: 'setTotalAreaMax', arguments: [newMax] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label="Площадь, м²">
      <InlineRangeAdvancedFilter
        valueMin={valueMin}
        valueMax={valueMax}
        onMinChange={handleMinChange}
        onMaxChange={handleMaxChange}
      />
    </AdvancedFilterRow>
  );
};
